import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatChipsModule } from '@angular/material/chips'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTableModule } from '@angular/material/table'
import { MatTooltipModule } from '@angular/material/tooltip'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { CarrierLookupsSelectorModule } from '../carrier-lookups-selector'
import { CustomFieldModule } from '../custom-field'
import { ResourceSelectorModule } from '../resource-selector'
import { CodeModifiersFormComponent } from './components/code-modifiers-form'
import { CodeModifiersSelectComponent } from './components/code-modifiers-select'
import { ProductDialogComponent } from './components/product-dialog/product-dialog.component'
import { ProductPriceDialogComponent } from './components/product-price-dialog/product-price-dialog.component'
import { ProductPricesComponent } from './components/product-prices'

const dialogs = [
  ProductDialogComponent,
  ProductPriceDialogComponent,
  // BulkProductsDialogComponent,
]

@NgModule({
  imports: [
    CarrierLookupsSelectorModule,
    CommonModule,
    CustomFieldModule,
    DirectivesModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTableModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    ResourceSelectorModule,
    TranslateModule,
  ],
  declarations: [
    ...dialogs,
    ProductPricesComponent,
    CodeModifiersSelectComponent,
    CodeModifiersFormComponent,
  ],
})
export class ClinicianProductDialogModule {}
